import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { formatDate } from "../../helpers/globalfunctions.js";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
import Modal from "react-modal";
import { List, SelectBox, DropDownBox } from "devextreme-react";
import * as XLSX from "xlsx";
import Swal from "sweetalert2";
import DataSource from "devextreme/data/data_source.js";
import moment from "moment";
import { DateFormat } from "../../helpers/fixcodes.js";
import ReactDatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
const DATE_RANGE_PRESETS = [
  { label: "Today", getRange: () => [moment(), moment()] },
  {
    label: "Yesterday",
    getRange: () => [moment().subtract(1, "day"), moment().subtract(1, "day")],
  },
  {
    label: "This Week",
    getRange: () => [moment().startOf("week"), moment().endOf("week")],
  },
  {
    label: "Last Week",
    getRange: () => [
      moment().subtract(1, "week").startOf("week"),
      moment().subtract(1, "week").endOf("week"),
    ],
  },
  {
    label: "This Month",
    getRange: () => [moment().startOf("month"), moment().endOf("month")],
  },
  {
    label: "Last Month",
    getRange: () => [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  },
];
const DATE_RANGE_PICKER_STYLES = `
  .dc-daterange-field {
    flex: 0 0 176px;
    min-width: 176px;
  }
  .dc-daterange-wrapper {
    display: block;
    width: 100%;
  }
  .dc-daterange-input {
    display: block;
    width: 100%;
    border: 1px solid #e3d5c6;
    border-radius: 6px;
    background: #fffdfb;
    padding: 5px 9px;
    min-height: 31px;
    font-size: 0.8rem;
    color: #333;
    box-sizing: border-box;
    outline: none;
    transition: border-color 0.15s ease;
  }
  .dc-daterange-input:hover {
    border-color: #d9c3aa;
  }
  .dc-daterange-input:focus {
    border-color: #f4691e;
    box-shadow: none;
  }
  .react-datepicker-popper {
    z-index: 1050;
  }
  .react-datepicker__day--in-range,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range) {
    background-color: #fdeee2;
    color: #6b4a2b;
  }
  .react-datepicker__day--keyboard-selected {
    background-color: #fdeee2;
    color: #6b4a2b;
  }
  .react-datepicker__day--range-start,
  .react-datepicker__day--range-end,
  .react-datepicker__day--selecting-range-start,
  .react-datepicker__day--selecting-range-end,
  .react-datepicker__day--selected {
    background-color: #f4691e;
    color: #ffffff;
  }
  .react-datepicker__header {
    background-color: #fdf7f2;
    border-bottom: 1px solid #e8d5c4;
  }
  .dc-daterange-shell {
    display: flex;
    align-items: stretch;
  }
  .dc-daterange-presets {
    display: flex;
    flex-direction: column;
    gap: 2px;
    padding: 8px 6px;
    background: #fdf7f2;
    border-right: 1px solid #e8d5c4;
    min-width: 112px;
  }
  .dc-preset-btn {
    border: none;
    background: transparent;
    text-align: left;
    padding: 6px 10px;
    font-size: 0.78rem;
    font-weight: 600;
    color: #6b4a2b;
    border-radius: 5px;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s ease, color 0.15s ease;
  }
  .dc-preset-btn:hover {
    background: #f5e7d8;
  }
  .dc-preset-btn.active {
    background: #f4691e;
    color: #ffffff;
  }
  .dc-daterange-months {
    position: relative;
  }
`;
export function CancelHotelComponent() {
  const [state, setState] = useState({
    datasource: null,
    isOpenModel: false,
    hotelDropdownList: [],
    airportDropdownList: [],
    filterDropdownEmployeeDataSource: [],
    loadPanelVisible: false,
    filterFromDatetime: new Date(),
    filterToDatetime: new Date(),
    airportCode: "",
    hotelId: 0,
    employeeNumber: "",
    hotelBooking: {
      airportCode: "",
      hotelName: "",
      hotelAddress: "",
      month: "",
      bookings: [],
    },
  });
  const refDropDownOperator = useRef(null);
  const refLstEmployees = useRef(null);
  const refDateRangePicker = useRef(null);
  const airlineCode = sessionStorage.getItem("session_airlineCode");

  const set = useCallback(
    (patch) => setState((prev) => ({ ...prev, ...patch })),
    [],
  );
  const applyDateRangePreset = useCallback(
    (preset) => {
      try {
        const [start, end] = preset.getRange();
        set({
          filterFromDatetime: start.toDate(),
          filterToDatetime: end.toDate(),
        });
        if (refDateRangePicker.current) {
          refDateRangePicker.current.setOpen(false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    [set],
  );

  const isDateRangePresetActive = useCallback(
    (preset) => {
      const [start, end] = preset.getRange();
      return (
        state.filterFromDatetime &&
        state.filterToDatetime &&
        start.isSame(state.filterFromDatetime, "day") &&
        end.isSame(state.filterToDatetime, "day")
      );
    },
    [state.filterFromDatetime, state.filterToDatetime],
  );

  const renderDateRangeCalendarContainer = useCallback(
    ({ className, children }) => (
      <CalendarContainer className={className}>
        <div className="dc-daterange-shell">
          <div className="dc-daterange-presets">
            {DATE_RANGE_PRESETS.map((preset) => (
              <button
                key={preset.label}
                type="button"
                className={`dc-preset-btn${
                  isDateRangePresetActive(preset) ? " active" : ""
                }`}
                onClick={() => applyDateRangePreset(preset)}
              >
                {preset.label}
              </button>
            ))}
          </div>
          <div className="dc-daterange-months">{children}</div>
        </div>
      </CalendarContainer>
    ),
    [applyDateRangePreset, isDateRangePresetActive],
  );

  // ── Shared request payload ──────────────────────────────────────────────────
  const buildReportRequest = useCallback(
    () => ({
      AirlineCode: airlineCode,
      UserMasterId: parseInt(sessionStorage.getItem("session_userId")),
      HotelId: state.hotelId,
      FromDate: formatDate(state.filterFromDatetime, "yyyy-MM-dd"),
      ToDate: formatDate(
        state.filterToDatetime ?? state.filterFromDatetime,
        "yyyy-MM-dd",
      ),
      AirportCode: state.airportCode,
      EmployeeNumber: state.employeeNumber,
    }),
    [
      airlineCode,
      state.hotelId,
      state.filterFromDatetime,
      state.filterToDatetime,
      state.airportCode,
      state.employeeNumber,
    ],
  );

  // ── Employee DataSource memoized — not recreated on every render ────────────
  const employeeDataSource = useMemo(
    () =>
      new DataSource({
        store: state.filterDropdownEmployeeDataSource,
        sort: "employeeName",
        paginate: true,
        pageSize: 10,
      }),
    [state.filterDropdownEmployeeDataSource],
  );

  // ── API: load dropdowns ─────────────────────────────────────────────────────
  const getCrewMember = useCallback(async () => {
    try {
      const res = await axiosGet(`/Crew/get-crew-dropdown`, {
        AirlineCode: airlineCode,
      });
      set({ filterDropdownEmployeeDataSource: res?.payload ?? [] });
    } catch {
      // dropdown stays empty on error
    }
  }, [airlineCode, set]);

  const getAirports = useCallback(async () => {
    try {
      const res = await axiosGet(`Airport/get-airport-dropdown/${airlineCode}`);
      set({ airportDropdownList: res?.payload ?? [] });
    } catch {
      // dropdown stays empty on error
    }
  }, [airlineCode, set]);

  const getHotelsList = useCallback(async () => {
    set({ loadPanelVisible: true });
    try {
      const response = await axiosGet(
        `Hotel/get-all-hotel-dropdown/${airlineCode}`,
      );
      set({
        hotelDropdownList:
          response?.payload?.sort((a, b) =>
            a.hotelName.localeCompare(b.hotelName),
          ) ?? [],
        loadPanelVisible: false,
      });
    } catch {
      set({ loadPanelVisible: false });
    }
  }, [airlineCode, set]);

  // ── Parallel init — replaces three sequential awaits ───────────────────────
  useEffect(() => {
    Promise.all([getHotelsList(), getAirports(), getCrewMember()]);
  }, [getHotelsList, getAirports, getCrewMember]);

  // ── Report actions ──────────────────────────────────────────────────────────
  const getCancelledHotel = useCallback(async () => {
    set({ loadPanelVisible: true });
    try {
      const response = await axiosPost(
        "Report/get-hotel-cancelled",
        buildReportRequest(),
      );
      set({ datasource: response?.payload ?? [], loadPanelVisible: false });
    } catch {
      set({ loadPanelVisible: false });
    }
  }, [buildReportRequest, set]);

  const clearData = useCallback(() => {
    setState({
      ...state,
      hotelDropdownList: state.hotelDropdownList,
      airportDropdownList: state.airportDropdownList,
      filterDropdownEmployeeDataSource: state.filterDropdownEmployeeDataSource,
    });
  }, [
    state.hotelDropdownList,
    state.airportDropdownList,
    state.filterDropdownEmployeeDataSource,
  ]);

  const openModelCrew = useCallback(
    (e, month, details, airportCode, hotelName, hotelAddress) => {
      try {
        const seen = new Set();
        const activities = (details ?? []).reduce((acc, item) => {
          const key = `${item.hotelBookingNumber}__${item.checkinTimeDisplay}__${item.isFlightDuty}__${item.activityTypeDisplay}__${item.activityTimeDisplay}`;
          if (!seen.has(key)) {
            seen.add(key);
            acc.push({
              hotelBookingNumber: item.hotelBookingNumber,
              checkinTimeDisplay: item.checkinTimeDisplay,
              isFlightDuty: item.isFlightDuty,
              activityTypeDisplay: item.activityTypeDisplay,
              activityTimeDisplay: item.activityTimeDisplay,
              key: key,
            });
          }
          return acc;
        }, []);

        const bookings = activities.map((activity) => ({
          hotelBookingNumber: activity.hotelBookingNumber,
          checkinTimeDisplay: activity.checkinTimeDisplay,
          isFlightDuty: activity.isFlightDuty,
          activityTypeDisplay: activity.activityTypeDisplay,
          activityTimeDisplay: activity.activityTimeDisplay,
          key: activity.key,
          details: (details ?? []).filter(
            (b) =>
              b.hotelBookingNumber === activity.hotelBookingNumber &&
              b.checkinTimeDisplay === activity.checkinTimeDisplay &&
              b.isFlightDuty === activity.isFlightDuty &&
              b.activityTypeDisplay === activity.activityTypeDisplay &&
              b.activityTimeDisplay === activity.activityTimeDisplay,
          ),
        }));

        set({
          isOpenModel: true,
          hotelBooking: {
            hotelName,
            hotelAddress,
            airportCode,
            month,
            bookings,
          },
          loadPanelVisible: false,
        });
      } catch {
        set({ loadPanelVisible: false });
      }
    },
    [set],
  );

  const modelClose = useCallback(() => {
    set({
      isOpenModel: false,
    });
  }, [set]);

  const downloadPopupExcel = useCallback((booking) => {
    const rows = booking.details.map((d, i) => ({
      "Sr No": i + 1,
      "Trip Type": d.isHotelCheckin ? "Check-in" : "Check-out",
      "Booking Number": d.hotelBookingNumber,
      "Employee #": d.employeeNumber,
      Crew: d.crewName,
      "Crew Type": d.airlineCrewType,
      "Crew Mobile": d.crewMobileNo,
      "Check In Time": d.checkinTime,
      "Cancellation Time": d.cancellationTime,
      "Cancellation Reason": d.cancellationReason,
      "Pick Up": d.pickupLocation,
      "Drop Off": d.dropoffLocation,
      "Initial Sync Time": d.initialSyncTime,
      "Last Sync Time": d.lastSyncTime,
    }));
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const display = (booking.activityTypeDisplay ?? "activity").replace(
      /[/\\?*[\]:?]/g,
      "_",
    );
    XLSX.writeFile(
      workbook,
      `Cancelled_Hotel_Stay_${display}_${booking.activityTimeDisplay}.xlsx`,
    );
  }, []);

  const downloadExcel = useCallback(() => {
    const allDetails = (state.datasource ?? []).flatMap((hotel) =>
      (hotel.summaries ?? []).flatMap((summary) =>
        (summary.details ?? []).map((d) => ({
          Hotel: hotel.hotelName,
          Airport: hotel.airportCode,
          Month: summary.month,
          ...d,
        })),
      ),
    );
    if (allDetails.length === 0) {
      Swal.fire({ title: "Info", text: "Data Not Found" });
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(allDetails);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, "CancelledHotelStayReport.xlsx");
  }, [state.datasource]);

  // ── Memoized renderers — stable references prevent List from reinitializing ─
  const renderEmployeeItem = useCallback(
    (item) => (
      <p className="mb-0">
        {item.employeeName}
        <span className="text-muted">
          {item?.employeeNumber && (
            <>
              <br />
              <small style={{ fontSize: "11px" }}>
                <i className="fas fa-user" />
                {` ${item.employeeNumber}`}
              </small>
            </>
          )}
        </span>
      </p>
    ),
    [],
  );

  const renderEmployeeList = useCallback(
    () => (
      <List
        ref={refLstEmployees}
        dataSource={employeeDataSource}
        height={400}
        keyExpr="employeeNumber"
        displayExpr="employeeFullName"
        searchEnabled={true}
        searchExpr={["employeeNumber", "employeeName", "employeeFullName"]}
        searchMode="contains"
        pageLoadMode="scrollBottom"
        showSelectionControls={true}
        selectionMode="single"
        indicateLoading={true}
        selectByClick={true}
        onItemClick={(item) => {
          set({ employeeNumber: item?.itemData?.employeeNumber ?? "" });
          if (refDropDownOperator.current?.instance) {
            refDropDownOperator.current.instance.close();
          }
        }}
        itemRender={renderEmployeeItem}
      />
    ),
    [employeeDataSource, renderEmployeeItem, set],
  );

  // ── Shared style tokens ────────────────────────────────────────────────────
  const labelStyle = {
    display: "block",
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "#6b21a8",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    marginBottom: 3,
  };
  const labelIconStyle = { marginRight: 4, opacity: 0.7 };

  const thStyle = {
    padding: "0.55rem 0.85rem",
    background: "#fff0e6",
    color: "#6b21a8",
    fontWeight: 700,
    fontSize: "0.75rem",
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    whiteSpace: "nowrap",
    borderRight: "1px solid rgba(255,255,255,0.15)",
  };
  const tdStyle = {
    padding: "0.5rem 0.85rem",
    borderBottom: "1px solid #f3e8ff",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
    color: "#000",
  };

  return (
    <>
      <style>{DATE_RANGE_PICKER_STYLES}</style>
      {/* ── Filter Panel ─────────────────────────────────────────────────── */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #e9d8fd",
          borderRadius: "10px 10px 0 0",
          borderBottom: "none",
          padding: "0 0 0 0",
          boxShadow: "0 2px 8px rgba(107,33,168,0.06)",
        }}
      >
        {/* Filter fields */}
        <div style={{ padding: "0.85rem 1.1rem 0.7rem" }}>
          <div className="row" style={{ rowGap: "0.5rem" }}>
            {/* Hotel */}
            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <label style={labelStyle}>
                <i className="fas fa-hotel" style={labelIconStyle} /> Hotel
              </label>
              <SelectBox
                dataSource={state.hotelDropdownList}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Hotel"
                value={state.hotelId}
                displayExpr="hotelName"
                valueExpr="hotelId"
                onSelectionChanged={(e) =>
                  set({ hotelId: e.selectedItem?.hotelId ?? 0 })
                }
                showClearButton={true}
                searchEnabled={true}
              />
            </div>

            {/* Airport */}
            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <label style={labelStyle}>
                <i className="fas fa-plane-departure" style={labelIconStyle} />{" "}
                Airport
              </label>
              <SelectBox
                dataSource={state.airportDropdownList}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Select Airport"
                value={state.airportCode}
                displayExpr="airportName"
                valueExpr="airportCode"
                onSelectionChanged={(e) =>
                  set({ airportCode: e.selectedItem?.airportCode ?? "" })
                }
                showClearButton={true}
                searchEnabled={true}
              />
            </div>

            {/* Employee */}
            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
              <label style={labelStyle}>
                <i className="fas fa-user" style={labelIconStyle} /> Employee
              </label>
              <DropDownBox
                ref={refDropDownOperator}
                value={state.employeeNumber}
                valueExpr="employeeNumber"
                displayExpr="employeeFullName"
                deferRendering={false}
                showClearButton={true}
                dataSource={state.filterDropdownEmployeeDataSource}
                onValueChanged={() => {
                  if (refLstEmployees.current?.instance) {
                    refLstEmployees.current.instance.unselectAll();
                    refLstEmployees.current.instance.option("searchValue", "");
                  }
                  set({ employeeNumber: "" });
                }}
                contentRender={renderEmployeeList}
                placeholder="Select Employee"
              />
            </div>

            {/* Date Range */}
            <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2 dc-daterange-field">
              <label style={labelStyle}>
                <i className="fas fa-calendar-alt" style={labelIconStyle} />{" "}
                From - To Date
              </label>
              <ReactDatePicker
                ref={refDateRangePicker}
                calendarContainer={renderDateRangeCalendarContainer}
                selectsRange={true}
                startDate={
                  state.filterFromDatetime
                    ? moment(state.filterFromDatetime).toDate()
                    : null
                }
                endDate={
                  state.filterToDatetime
                    ? moment(state.filterToDatetime).toDate()
                    : null
                }
                onChange={([start, end]) => {
                  set({
                    filterFromDatetime: start,
                    filterToDatetime: end,
                  });
                }}
                dateFormat="MM/dd/yyyy"
                placeholderText="MM/dd/yyyy - MM/dd/yyyy"
                onChangeRaw={(e) => e.preventDefault()}
                className="dc-daterange-input"
                wrapperClassName="dc-daterange-wrapper"
                monthsShown={2}
                showPopperArrow={false}
                portalId="dc-daterange-portal"
              />
            </div>

            {/* Action buttons */}
            <div
              className="col-xs-2 col-sm-2 col-md-2 col-lg-2"
              style={{
                display: "flex",
                alignItems: "flex-end",
                gap: "0.4rem",
                paddingBottom: "2px",
              }}
            >
              <button
                type="button"
                onClick={getCancelledHotel}
                disabled={state.loadPanelVisible}
                className="btn btn-primary btn-sm"
              >
                <i
                  className={`fas fa-${state.loadPanelVisible ? "spinner fa-spin" : "search"}`}
                />
                &nbsp;Search
              </button>
              <button
                type="button"
                onClick={clearData}
                className="btn btn-secondary btn-sm"
              >
                <i className="fas fa-times" /> Clear
              </button>
              <button
                type="button"
                onClick={downloadExcel}
                className="btn btn-outline-primary btn-sm"
              >
                <i className="fas fa-file-excel" />
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ── Data Grid ────────────────────────────────────────────────────── */}
      <div
        style={{
          background: "#fff",
          border: "1px solid #e9d8fd",
          borderRadius: "0 0 10px 10px",
          boxShadow: "0 4px 16px rgba(107,33,168,0.08)",
          overflow: "hidden",
        }}
      >
        {/* Grid title bar */}
        <div
          style={{
            borderBottom: "2px solid #e9d8fd",
            padding: "0.55rem 1.1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#faf5ff",
          }}
        >
          <div
            style={{ display: "flex", alignItems: "center", gap: "0.45rem" }}
          >
            <i
              className="fas fa-table"
              style={{ color: "#7c3aed", fontSize: "0.85rem" }}
            />
            <span
              style={{
                fontWeight: 700,
                fontSize: "0.78rem",
                color: "#6b21a8",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Cancelled Crew Hotel Summary
            </span>
          </div>
          {state.datasource && (
            <span style={{ fontSize: "0.72rem", color: "#9e9e9e" }}>
              {state.datasource.length} hotel
              {state.datasource.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        {/* Table */}
        <div style={{ overflowX: "auto" }}>
          {state.datasource ? (
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.82rem",
              }}
            >
              <thead>
                <tr>
                  <th style={thStyle}>Stay Location</th>
                  <th style={thStyle}>Layover</th>
                  {state.datasource?.[0]?.summaries?.map((item) => (
                    <th
                      key={item.month}
                      style={{ ...thStyle, textAlign: "center" }}
                    >
                      {item.month}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {state.datasource.map((item, idx) => (
                  <tr
                    key={`${item.hotelName}-${item.airportCode}`}
                    style={{ background: idx % 2 === 0 ? "#fff" : "#faf5ff" }}
                  >
                    <td style={tdStyle}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.4rem",
                        }}
                      >
                        <i
                          className="fas fa-hotel"
                          style={{ color: "#a855f7", fontSize: "0.75rem" }}
                        />
                        <span style={{ fontWeight: 500 }}>
                          {item.hotelName}
                        </span>
                      </div>
                    </td>
                    <td style={tdStyle}>
                      <span
                        style={{
                          background: "#ede9fe",
                          padding: "1px 8px",
                          borderRadius: 20,
                          fontSize: "0.75rem",
                          fontWeight: 600,
                        }}
                      >
                        {item.airportCode}
                      </span>
                    </td>
                    {item.summaries?.map((_item) => (
                      <td
                        key={_item.month}
                        style={{ ...tdStyle, textAlign: "center" }}
                      >
                        {_item.cancelCount > 0 ? (
                          <span
                            title="Click to view details"
                            onClick={(e) =>
                              openModelCrew(
                                e,
                                _item.month,
                                _item.details,
                                item.airportCode,
                                item.hotelName,
                                item.hotelAddress,
                              )
                            }
                            style={{
                              color: "#6b21a8",
                              fontWeight: 700,
                              fontSize: "0.9rem",
                              cursor: "pointer",
                              textDecoration: "underline",
                              textDecorationColor: "#6b21a8",
                              textUnderlineOffset: "3px",
                              transition:
                                "color 0.15s, text-decoration-color 0.15s",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.color = "#8E6448";
                              e.currentTarget.style.textDecorationColor =
                                "#8E6448";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.color = "#6b21a8";
                              e.currentTarget.style.textDecorationColor =
                                "#6b21a8";
                            }}
                          >
                            {_item.cancelCount}
                          </span>
                        ) : (
                          <span
                            style={{ color: "#d1d5db", fontSize: "0.75rem" }}
                          >
                            —
                          </span>
                        )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "3rem 1rem",
                color: "#9e9e9e",
              }}
            >
              <i
                className="fas fa-filter"
                style={{
                  fontSize: "2rem",
                  display: "block",
                  marginBottom: "0.75rem",
                  color: "#d8b4fe",
                }}
              />
              <div
                style={{
                  fontWeight: 600,
                  marginBottom: "0.25rem",
                  color: "#6b21a8",
                }}
              >
                No results yet
              </div>
              <div style={{ fontSize: "0.82rem" }}>
                Select filters above and click Search
              </div>
            </div>
          )}
        </div>
      </div>

      <Modal
        ariaHideApp={false}
        isOpen={state.isOpenModel}
        onRequestClose={modelClose}
        shouldCloseOnOverlayClick={false}
        contentLabel="Crew Details Modal"
        style={{
          overlay: {
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          content: {
            /* override every default react-modal positional rule */
            position: "relative",
            inset: "unset",
            top: "unset",
            left: "unset",
            right: "unset",
            bottom: "unset",
            transform: "none",
            marginRight: 0,
            margin: 0,
            /* sizing */
            width: "80vw",
            maxWidth: 1100,
            maxHeight: "82vh",
            minHeight: 100,
            /* layout */
            display: "flex",
            flexDirection: "column",
            /* appearance */
            padding: 0,
            border: "none",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            background: "#fff",
          },
        }}
      >
        {/* ── Header ───────────────────────────────────────────────────── */}
        <div
          style={{
            background: "#6b21a8",
            padding: "0.4rem 1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexShrink: 0,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0.6rem" }}>
            <i
              className="fas fa-hotel"
              style={{ color: "#fff", fontSize: "1rem" }}
            />
            <span
              style={{ color: "#fff", fontWeight: 600, fontSize: "0.95rem" }}
            >
              {/* {state.hotelBooking?.hotelName || "Hotel Details"} */}
              Cancelled Crew Hotel Summary
            </span>
          </div>

          {/* Close button */}
          <button
            type="button"
            onClick={modelClose}
            aria-label="Close"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 30,
              height: 30,
              borderRadius: "50%",
              border: "2px solid rgba(255,255,255,0.6)",
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              fontSize: "1rem",
              lineHeight: 1,
              cursor: "pointer",
              transition: "background 0.2s",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,0.3)")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.background = "rgba(255,255,255,0.15)")
            }
          >
            ×
          </button>
        </div>

        {/* ── Info bar ─────────────────────────────────────────────────── */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1.5rem",
            padding: "0.5rem 1.25rem",
            background: "#f5f0fc",
            borderBottom: "1px solid #e2d4f0",
            flexShrink: 0,
            flexWrap: "wrap",
          }}
        >
          {/* Hotel name + address stacked */}
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.15rem" }}
          >
            <div
              style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}
            >
              <i
                className="fas fa-hotel"
                style={{ color: "#6b21a8", fontSize: "0.8rem", flexShrink: 0 }}
              />
              <span
                style={{
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  color: "#3b0764",
                }}
              >
                {state.hotelBooking?.hotelName || "—"}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.4rem",
                paddingLeft: "1.2rem",
              }}
            >
              <i
                className="fas fa-location-arrow"
                style={{
                  color: "#8E6448",
                  fontSize: "0.7rem",
                  flexShrink: 0,
                }}
              />
              <span
                style={{
                  fontSize: "0.73rem",
                  color: "#8E6448",
                  fontWeight: 500,
                }}
              >
                {state.hotelBooking?.hotelAddress || "—"}
              </span>
            </div>
          </div>

          <div
            style={{
              width: 1,
              height: 36,
              background: "#d8b4fe",
              flexShrink: 0,
            }}
          />

          <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
            <i
              className="fas fa-map-marker-alt"
              style={{ color: "#6b21a8", fontSize: "0.8rem" }}
            />
            <span
              style={{ fontSize: "0.8rem", fontWeight: 600, color: "#3b0764" }}
            >
              {state.hotelBooking?.airportCode || "—"}
            </span>
          </div>

          <div
            style={{
              width: 1,
              height: 36,
              background: "#d8b4fe",
              flexShrink: 0,
            }}
          />

          <div style={{ display: "flex", alignItems: "center", gap: "0.4rem" }}>
            <i
              className="fas fa-calendar-alt"
              style={{ color: "#6b21a8", fontSize: "0.8rem" }}
            />
            <span
              style={{ fontSize: "0.8rem", fontWeight: 600, color: "#3b0764" }}
            >
              {state.hotelBooking?.month || "—"}
            </span>
          </div>
        </div>

        {/* ── Scrollable body ───────────────────────────────────────────── */}
        <div
          style={{
            flex: 1,
            overflowY: "auto",
            padding: "1rem 1.25rem",
            background: "#fafafa",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              marginBottom: "0.85rem",
              paddingBottom: "0.6rem",
              borderBottom: "2px solid #e2d4f0",
              flexWrap: "wrap",
            }}
          >
            <i
              className="fas fa-exchange-alt"
              style={{ color: "#8E6448", fontSize: "1rem" }}
            />
            <span
              style={{
                fontSize: "0.95rem",
                fontWeight: 700,
                color: "#6b21a8",
                letterSpacing: "0.02em",
              }}
            >
              Crew Hotel Arrivals &amp; Departures – Cancelled Trips
            </span>
          </div>

          {state.hotelBooking?.bookings?.length > 0 ? (
            state.hotelBooking.bookings.map((item, sn) => (
              <div
                key={`${item.key}-${sn}`}
                style={{
                  background: "#fff",
                  border: "1px solid #e2d4f0",
                  borderRadius: 8,
                  marginBottom: "1rem",
                  overflow: "hidden",
                  boxShadow: "0 1px 4px rgba(107,33,168,0.06)",
                }}
              >
                {/* Activity group header */}
                <div
                  style={{
                    background: "#f5f0fc",
                    borderBottom: "1px solid #e2d4f0",
                    padding: "0.5rem 1rem",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Left — Sr No badge */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <span
                      style={{
                        background: "#6b21a8",
                        color: "#fff",
                        borderRadius: "50%",
                        width: 24,
                        height: 24,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "0.72rem",
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      {sn + 1}
                    </span>
                    <span
                      style={{
                        fontSize: "0.7rem",
                        color: "#6b21a8",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                      }}
                    >
                      Sr No
                    </span>
                  </div>

                  {/* Right — Activity + time + download */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1.25rem",
                    }}
                  >
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: "0.65rem",
                          color: "#9e9e9e",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                        }}
                      >
                        Booking No
                      </div>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          color: "#3b0764",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.35rem",
                          justifyContent: "flex-end",
                        }}
                      >
                        <i
                          className="fas fa-bookmark"
                          style={{ fontSize: "0.75rem", color: "#8E6448" }}
                        />
                        {item.details?.[0]?.hotelBookingNumber || "—"}
                      </div>
                    </div>
                    <div
                      style={{ width: 1, height: 30, background: "#d8b4fe" }}
                    />
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: "0.65rem",
                          color: "#9e9e9e",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                        }}
                      >
                        {item.isFlightDuty ? "Flight" : "Activity"}
                      </div>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          color: "#3b0764",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.35rem",
                          justifyContent: "flex-end",
                        }}
                      >
                        <i
                          className={
                            item.isFlightDuty
                              ? "fas fa-plane"
                              : "fas fa-building"
                          }
                          title={
                            item.isFlightDuty ? "Flight Duty" : "Ground Duty"
                          }
                          style={{
                            fontSize: "0.75rem",
                            color: item.isFlightDuty ? "#6b21a8" : "#8E6448",
                          }}
                        />
                        {item.activityTypeDisplay}
                      </div>
                    </div>
                    <div
                      style={{ width: 1, height: 30, background: "#d8b4fe" }}
                    />
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: "0.65rem",
                          color: "#9e9e9e",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                        }}
                      >
                        {item.isFlightDuty ? "Flight Time" : "Activity Time"}
                      </div>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          color: "#3b0764",
                          display: "flex",
                          alignItems: "center",
                          gap: "0.35rem",
                          justifyContent: "flex-end",
                        }}
                      >
                        <i
                          className={
                            item.isFlightDuty
                              ? "fas fa-plane"
                              : "fas fa-building"
                          }
                          style={{
                            fontSize: "0.75rem",
                            color: item.isFlightDuty ? "#6b21a8" : "#8E6448",
                          }}
                        />
                        {item.activityTimeDisplay
                          ? moment(item.activityTimeDisplay).format(
                              DateFormat.MomentDisplayDateTime24Format,
                            )
                          : "—"}
                      </div>
                    </div>
                    <div
                      style={{ width: 1, height: 30, background: "#d8b4fe" }}
                    />
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          fontSize: "0.65rem",
                          color: "#9e9e9e",
                          textTransform: "uppercase",
                          letterSpacing: "0.04em",
                        }}
                      >
                        <i
                          className="fas fa-sign-in-alt"
                          style={{ marginRight: "0.3rem", color: "#6b21a8" }}
                        />
                        Check-in
                      </div>
                      <div
                        style={{
                          fontSize: "0.85rem",
                          fontWeight: 600,
                          color: "#3b0764",
                        }}
                      >
                        {moment(item.activityTime).format(
                          DateFormat.MomentDisplayDateFormat,
                        )}
                      </div>
                    </div>
                    <div
                      style={{ width: 1, height: 30, background: "#d8b4fe" }}
                    />
                    <button
                      type="button"
                      onClick={() => downloadPopupExcel(item)}
                      className="btn btn-outline-primary btn-sm"
                      title="Download as Excel"
                      style={{ padding: "0.25rem 0.5rem", flexShrink: 0 }}
                    >
                      <i className="fas fa-file-excel" />
                    </button>
                  </div>
                </div>

                {/* Detail table */}
                <div style={{ overflowX: "auto" }}>
                  <table
                    cellPadding="0"
                    border="0"
                    cellSpacing="1"
                    className="custom-table mb-0"
                  >
                    <thead className="thead-dark">
                      <tr>
                        <th>Sr No</th>
                        <th>Trip Type</th>
                        <th>Employee #</th>
                        <th>Crew</th>
                        <th>Crew Type</th>
                        <th>Crew Mobile</th>
                        <th>Check In Time</th>
                        <th>Cancellation Time</th>
                        <th>Cancellation Reason</th>
                        <th>Pick Up</th>
                        <th>Drop Off</th>
                        <th>Initial Sync Time</th>
                        <th style={{ whiteSpace: "nowrap" }}>Last Sync Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {item.details.map((_item, k) => (
                        <tr key={`${_item.employeeNumber}-${k}`}>
                          <td>{k + 1}</td>
                          <td>
                            {_item.isHotelCheckin ? "Check-in" : "Check-out"}
                          </td>
                          <td>{_item.employeeNumber}</td>
                          <td>{_item.crewName}</td>
                          <td>{_item.airlineCrewType}</td>
                          <td>{_item.crewMobileNo}</td>
                          <td>{_item.checkinTime}</td>
                          <td>{_item.cancellationTime}</td>
                          <td>{_item.cancellationReason}</td>
                          <td>{_item.pickupLocation}</td>
                          <td>{_item.dropoffLocation}</td>
                          <td>{_item.initialSyncTime}</td>
                          <td>{_item.lastSyncTime}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ))
          ) : (
            <div
              style={{ textAlign: "center", padding: "2rem", color: "#9e9e9e" }}
            >
              <i
                className="fas fa-inbox fa-2x"
                style={{ display: "block", marginBottom: "0.5rem" }}
              />
              <b>No Data Found</b>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
}
